export default __webpack_public_path__ + "static/media/13.5a028faf.jpg";